import { galleryItems } from "@/mocks/jiuse";

function SectionTitle({ overline, title, hint, anchor }: { overline: string; title: string; hint: string; anchor: string }) {
  return (
    <div id={anchor} className="flex scroll-mt-24 flex-col gap-3 border-b-2 border-foreground-950 pb-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-[0.26em] text-primary-700">
          <i className="ri-archive-drawer-line text-sm" aria-hidden="true" />
          {overline}
        </p>
        <h2 className="font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">{title}</h2>
      </div>
      <p className="flex items-center gap-2 whitespace-nowrap text-[13px] text-foreground-600">
        <i className="ri-shield-check-line text-primary-600" aria-hidden="true" />
        {hint}
      </p>
    </div>
  );
}

export { SectionTitle };

export default function Gallery() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          anchor="gallery"
          overline="图鉴 · 原图相册库"
          title="九色黑料图片，分区点开即看"
          hint="画面细节 · 原图级呈现"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {galleryItems.map((it) => (
            <article
              key={it.title}
              className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-100 transition hover:border-primary-300"
            >
              <a href="#gallery" className="block">
                <div className="relative overflow-hidden bg-background-200">
                  <img
                    src={it.cover}
                    alt={`${it.title} - 九色黑料图片`}
                    title={`${it.title} 九色黑料图片`}
                    className="aspect-[4/5] w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-[11px] font-semibold text-background-50 backdrop-blur">
                    {it.tag}
                  </span>
                  <span className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full bg-primary-600 text-background-50 opacity-0 transition group-hover:opacity-100">
                    <i className="ri-zoom-in-line" aria-hidden="true" />
                  </span>
                  <div className="absolute inset-x-0 bottom-0 flex items-end justify-between bg-gradient-to-t from-foreground-950/60 to-transparent px-3 pb-2 pt-8 text-[12px] text-background-50">
                    <span className="flex items-center gap-1"><i className="ri-eye-line" aria-hidden="true" />{it.views}</span>
                    <span className="whitespace-nowrap">点开看原图</span>
                  </div>
                </div>
              </a>
              <div className="px-4 pb-4 pt-3">
                <h3 className="font-display text-base font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700">
                  <a href="#gallery">{it.title}</a>
                </h3>
                <p className="mt-1.5 text-[13px] leading-6 text-foreground-600">{it.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}